import ViewPrgressComments from "./ViewPrgressComments";

const MemberProgress = ({ tab16, MemberDetails }) => {
  return (
    <div role="tabpanel" id="tab-16" className={`tab-pane ${tab16}`}>
      <div className="panel-body progress-container-scoped">
        <ViewPrgressComments memberId={MemberDetails.id} />
      </div>
    </div>
  );
};

export default MemberProgress;
